import * as React from 'react';
import { Button } from "primereact/button";
import Translate from '../../functions/translate';

const offlineStatusComponent = (props) => {

  const offlineStatus =
    <div className="offline-component">
      {Translate('Application is working Offline.')}
    </div>;

  let offlineMode = !navigator.onLine;

  return (
    <>
      {offlineMode ? offlineStatus : null}
    </>
  )
}

export default offlineStatusComponent;